import { gql } from 'apollo-boost'
export const getUsers = gql`
  {
    users {
      id
      username
      firstname
      lastname
      email
      alternativeEmail
      departmentId
      department {
        id
        name
      }
      companyId
      company {
        id
        name
        short
      }
      positionId
      position {
        id
        name
      }
      roleID
      role {
        id
        name
      }
      weight
      reportToId
      reportTo {
        id
        name
      }
      description
    }
  }
`
